var _path, _path2, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconAddCircle(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.52942 4.70594C7.52942 4.44604 7.74011 4.23535 8.00001 4.23535C8.25991 4.23535 8.4706 4.44604 8.4706 4.70594V11.2942C8.4706 11.5541 8.25991 11.7648 8.00001 11.7648C7.74011 11.7648 7.52942 11.5541 7.52942 11.2942V4.70594Z",
    fill: "#245CA6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.70588 8.4707C4.44598 8.4707 4.23529 8.26001 4.23529 8.00011C4.23529 7.74022 4.44598 7.52953 4.70588 7.52953H11.2941C11.554 7.52953 11.7647 7.74022 11.7647 8.00011C11.7647 8.26001 11.554 8.4707 11.2941 8.4707H4.70588Z",
    fill: "#245CA6"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 7.5,
    stroke: "#245CA5"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAddCircle);
export default __webpack_public_path__ + "static/media/icon-add-circle.930904f5.svg";
export { ForwardRef as ReactComponent };